import { addListener, removeListener } from './eventListeners.state';

const LOGGING_LISTENER_ID = '__analytics_logging__';
const LOGGING_STORAGE_KEY = 'analyticsLoggingEnabled';

export const startEventsLogging = (): void => {
  addListener(LOGGING_LISTENER_ID, (title, attributes) => {
    /* eslint-disable no-console */
    console.group(title);
    console.table(attributes);
    console.groupEnd();
    /* eslint-enable no-console */
  });
};

/** @public */
export const stopEventsLogging = (): void => {
  removeListener(LOGGING_LISTENER_ID);
};

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    enableAnalyticsLogging: () => void;
    disableAnalyticsLogging: () => void;
  }
}

export const attachAnalyticsCLI = (): void => {
  /* eslint-disable no-console */
  window.enableAnalyticsLogging = () => {
    startEventsLogging();
    localStorage.setItem(LOGGING_STORAGE_KEY, 'true');
    console.log(
      'Analytics logging enabled. To disable it, run `disableAnalyticsLogging()`'
    );
  };
  window.disableAnalyticsLogging = () => {
    stopEventsLogging();
    localStorage.setItem(LOGGING_STORAGE_KEY, 'false');
    console.log(
      'Analytics logging disabled. To enable it, run `enableAnalyticsLogging()`'
    );
  };
  /* eslint-enable no-console */
};

export const isAnalyticsLoggingPersisted = (): boolean =>
  localStorage.getItem(LOGGING_STORAGE_KEY) === 'true';

export const isAnalyticsLoggingDisabledByUser = (): boolean =>
  localStorage.getItem(LOGGING_STORAGE_KEY) === 'false';
